<template>
    <div>
      <Layout ref="layoutRef" :selectedOption="1" />
      <h4>Vademecum</h4>
      <hr>
      <!-- Iframe -->
      <div class="iframe-container" style="margin-bottom: 20px;">
        <iframe src="https://www.vademecum.es/" frameborder="0" style="width: 100%; height: 750px;"></iframe>
      </div>
      <Footer/>
    </div>
  </template> 
  <script>
  import Layout from '@/components/Layout.vue'
  import Footer from '@/components/Footer.vue'
  export default {
    components : {
      Layout, Footer
    },
    mounted () {
      this.$refs.layoutRef.toggleProcesos()
      this.$refs.layoutRef.toggleReportes()
      this.$refs.layoutRef.toggleParametros()
      this.$refs.layoutRef.toggleAyuda()
    }
  }
  </script>